import { useReducer } from 'react';
import { customTableReducer } from '../../../../../hooks/tableHook';
import { DC } from './variables';

export const useReferencesReducer = ({
  initialSearchParams,
  resetSearchParams,
}) => {
  const [searchParams, dispatch] = useReducer(
    customTableReducer({ resetSearchParams, customReducer }),
    initialSearchParams
  );
  return [searchParams, dispatch];
};

const customReducer = (state, { type, payload }) => {
  switch (type) {
    case DC.COUNTRY:
    case DC.ADDED_BY:
    case DC.BRANDS:
      return {
        ...state,
        [type]: [...payload],
        [DC.FILTERS_SET]: true,
      };
    case DC.ONLY_ACTIVE:
      return {
        ...state,
        [type]: payload,
        [DC.FILTERS_SET]: true,
      };
    default:
      return state;
  }
};
